import {CreateToastFnReturn} from "@chakra-ui/toast";
import {Company, CompanyOperator, CompanyOperatorRoleType} from "../../api/data-api";
import {UserLoginResult} from "../../api/user-api";

export function errorNotify(err: any, toast: CreateToastFnReturn) {
    console.log("Error status code is: " + err);
    toast({title: "Error", description: `code: [${err}]`, status: "error"});
}

export function errorNotifySilent(err: any) {
    console.log("Error status code is: " + err);
}

export function checkAccess(userLoginResult: UserLoginResult | null, company: Company | null, companyOperators: CompanyOperator[] | null, minRoleType: CompanyOperatorRoleType | null): boolean {
    if (!userLoginResult || (!userLoginResult.isOperator && !userLoginResult.isEmployer))
        return false;
    if (!company)
        return false;
    if (!minRoleType)
        minRoleType = "READ";
    if (!companyOperators)
        companyOperators = [];
    if (userLoginResult.isEmployer && company.USER_ID === userLoginResult.userId)
        return true;
    let operator = companyOperators.find(c => c.COMPANY_ID === company.ID);
    if (operator) {
        if (operator.USER_ID !== userLoginResult.userId)
            return false;
        switch (operator.ROLE_TYPE) {
            case "READ":
                if (minRoleType === "READ")
                    return true;
                break;
            case "EDIT":
                if (minRoleType === "READ" || minRoleType === "EDIT")
                    return true;
                break;
            case "EDIT_AND_CONFIRM":
                if (minRoleType === "READ" || minRoleType === "EDIT" || minRoleType === "EDIT_AND_CONFIRM")
                    return true;
                break;
            case "OWNER":
                if (minRoleType === "READ" || minRoleType === "EDIT" || minRoleType === "EDIT_AND_CONFIRM" || minRoleType === "OWNER")
                    return true;
                break;
        }
    }
    return false;
}

export function equalArrays<T>(a: Array<T>, b: Array<T>): boolean {
    if (a === b) return true; // Identical arrays are equal
    if (a.length !== b.length) return false; // Different-size arrays are not equal
    for (let i = 0; i < a.length; i++) { // Loop through all elements
        if (a[i] !== b[i]) return false; // If any differ, arrays are not equal
    }
    return true; // Otherwise they are equal
}

export function sleep<T>(ms: number): Promise<T> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

